/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PrintersOverViewDto } from '../models/PrintersOverviewDto';
import type { PrintersOverViewDtoListData } from '../models/PrintersOverviewDtoListData';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PrintersOverviewService {
 
  /**
   * @param formData 
   * @returns PrintersOverViewDtoListData Success
   * @throws ApiError
   */

public static getPrintersOverview(
): CancelablePromise<Array<PrintersOverViewDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/WebScraping/get-branches-printers-status',
    });
  }

      /**
   * @param id 
   * @returns PrintersOverViewDtoListData Success
   * @throws ApiError
   */
      public static getPrintersOverviewByBranch(
        id: number,
        ): CancelablePromise<Array<PrintersOverViewDto>> {
            return __request(OpenAPI, {
              method: 'GET',
              url: '/WebScraping/get-printers-by-branch/{id}',
              path: {
                'id': id,
              },
            });
          }

    /**
   * @param id 
   * @returns PrintersOverViewDto Success
   * @throws ApiError
   */
  public static getPrintersOverview1(
      id: number,
      ): CancelablePromise<PrintersOverViewDto> {
          return __request(OpenAPI, {
            method: 'GET',
            url: '/WebScraping/{id}',
            path: {
              'id': id,
            },
          });
        }

  /**
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
public static postPrintersOverview(
formData?: {
deviceName?: string ;
iPAddress?: string;
branchId?: number;
cartridgeNum?: string | null;
}, 
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/WebScraping',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deletePrinter(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/WebScraping/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static putPrintersOverview(
id: number,
formData?: {
deviceName?: string;
ipaddress?: string;
branchId?: number;
cartridgeNum?: string;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/WebScraping/{id}',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }
}
